module.exports = __webpack_public_path__ + "static/media/title-img.0e8310f7.svg";